import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const jobDayApi = createApi({
  reducerPath: "/core/day/job",
  baseQuery: axiosBaseQuery,
  tagTypes: ["jobDay"],
  endpoints: (builder) => ({
    jobDay: builder.query<{ data: any[]; success: any }, string | void>({
      providesTags: ['jobDay'],
      query: (query = '') => ({
        url: "/core/day/job" + query,
        method: "GET",
      }),
      transformResponse: (response: any) => {
        return {
          data: response?.data,
          success: response?.success,
        };
      },
    }),
  })
})

export const { useJobDayQuery } = jobDayApi;
export { jobDayApi };
